import { apiClient } from '../../lib/api-client';
import { PATIENT_UHID_SEARCH_LIMIT } from '../../lib/patient-uhid-search';
import type {
  CreateOtCasePayload,
  OtCase,
  OtCaseStatus,
  OtListFilters,
  OtLookupExtra,
  OtLookupOption,
  OtSchedulePayload,
  Pagination,
} from './types';

interface ApiResponse<T> { success: true; data: T }
interface PaginatedResponse<T> extends ApiResponse<T[]> { pagination: Pagination }

const compactParams = (params: object) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null),
);

export const fetchOtCases = async (filters: OtListFilters) => {
  const response = await apiClient.get<PaginatedResponse<OtCase>>('/ot/cases', { params: compactParams(filters) });
  return response.data;
};

export const fetchOtCase = async (id: string) => {
  const response = await apiClient.get<ApiResponse<OtCase>>(`/ot/cases/${id}`);
  return response.data.data;
};

export const createOtCase = async (payload: CreateOtCasePayload) => {
  const response = await apiClient.post<ApiResponse<OtCase>>('/ot/cases', payload);
  return response.data.data;
};

export const scheduleOtCase = async (id: string, payload: OtSchedulePayload) => {
  const response = await apiClient.patch<ApiResponse<OtCase>>(`/ot/cases/${id}/schedule`, payload);
  return response.data.data;
};

export const updateOtCaseStatus = async (id: string, status: OtCaseStatus) => {
  const response = await apiClient.patch<ApiResponse<OtCase>>(`/ot/cases/${id}/status`, { status });
  return response.data.data;
};

export const fetchOtLookups = async (type: string, search = '', extra: OtLookupExtra = {}) => {
  const response = await apiClient.get<ApiResponse<OtLookupOption[]>>('/ot/lookups', { params: compactParams({ type, search, ...extra, limit: type === 'patients' ? PATIENT_UHID_SEARCH_LIMIT : 500 }) });
  return response.data.data;
};
